import CommonUiModel from "../common/commonUiModel";

const RegionModel = new CommonUiModel({
    title: "Region",
    formTitle: 'SCM Region',
    gridTitle: 'SCM Region',
    module: 'Region',
    columns: [
        { field: 'RegionId', gridLabel: 'SCM Region Id', width: 120, type: 'number', label: null },
        { field: 'RegionName', label: 'SCM Region', required: true, max: 100 },
        { field: 'Description', label: 'Description', multiline: true },
        { field: 'Notes', label: 'Notes', multiline: true }
    ]
});

export default RegionModel;